import React from 'react';
import ServerScriptRunner from './ServerScriptRunner';
import ScriptLogViewer from './ScriptLogViewer';
import './index.css';

const ServerScripts = () => {
  return (
    <div className="server-scripts-panel">
      <div className="panel-header">
        <h1>Server Script Management</h1>
        <p>Run and monitor build and deployment operations</p>
      </div>
      
      <div className="panel-content">
        <div className="tool-section">
          <h2>Build and Deploy</h2>
          <div className="script-tools">
            <div className="tool-card">
              <h3>Build and Deploy Scripts</h3>
              <p>Execute build and deployment operations for your applications</p>
              <ServerScriptRunner buttonText="Run Selected Script" />
            </div>
          </div>
        </div>
        
        <div className="log-section">
          <h2>Script Execution Logs</h2>
          <ScriptLogViewer />
        </div>
      </div>
    </div>
  );
};

export default ServerScripts;